<template>
	<CompanyForm
		ref="CompanyForm"
		:custom-label="$t('foreign_lawyer').toString()"
		:options="lawyerOfficeOptions"
		:options-label="$t('lawyer').toString()"
		v-model="model"
		:required="required"
		:allow-empty="allowEmpty"
		:disabled="disabled"
	>
		<template #warning>
			<div class="flex flex-wrap hidden">
				<h5 class="text-red-500 text-lg font-semibold">ACHTUNG:</h5>
			</div>

			<div class="flex flex-wrap hidden">
				<p class="text-red-500 text-left mb-5">
					Gewählte Kanzlei ist kein Systempartner. Kunde muss den Anwalt selbst beauftragen. Das System kann keine Vollmacht erstellen! Geben Sie die
					Kontaktdaten bitte ein:
				</p>
			</div>
		</template>
	</CompanyForm>
</template>

<script>
import { LawyerofficesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import { _regxp } from '@/plugins/Utils';
import CompanyForm from '@/components/damagecases/forms/CompanyForm';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';

export default {
	components: { CompanyForm },
	name: 'LawyerOfficeForm',
	mixins: [Validate, Authentication],
	props: {
		value: {},
		required: { default: true },
		allowEmpty: { default: false },
		disabled: { default: false },
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			RepairShopRepository.lawyersOffices(RepairShopRepository.repairShopId).then(response => {
				const ownPartnerLawyerOfficeOptions = response.data.data;
				RepairShopRepository.premiumLawyersOffices(RepairShopRepository.repairShopId).then(response => {
					const premiumLawyerOfficeOptions = response.data.data.map(entry => ({
						...entry,
						premiumReferral: true,
					}));
					this.lawyerOfficeOptions = [...ownPartnerLawyerOfficeOptions, ...premiumLawyerOfficeOptions];
				});
			});
		} else {
			LawyerofficesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.lawyerofficesGet()
				.then(ressource => {
					this.lawyerOfficeOptions = ressource.data.filter(function(el) {
						return el != null;
					});
				});
		}
	},
	data() {
		return {
			regxp: _regxp(),
			lawyerOfficeOptions: [],
			lawyerOfficeSelectedOption: null,
		};
	},
	methods: {
		updateValue() {
			this.$emit('input', {
				...this.$data.lawyerOffice,
			});
		},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>

<style lang="sass" scoped></style>
